(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const showView = (root, index) => {
    if (!root.querySelector('[data-preview-panel="' + index + '"]')) return;
    root.querySelectorAll('[data-preview-panel]').forEach(panel => panel.hidden = Number(panel.dataset.previewPanel) !== index);
    root.querySelectorAll('[data-preview-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.previewIndex) === index)));
  };
  const receipt = (root, variant, {selectView = true} = {}) => {
    if (!variant || !['bottoms', 'art'].includes(root.dataset.kind)) return;
    const digital = /png|digital/i.test(variant.title);
    const message = root.querySelector('[data-preview-receipt]');
    if (message) message.textContent = root.dataset.kind === 'bottoms' ? variant.title.replace(/\s*—\s*no pants$/i, '') : `${variant.title}. ${root.dataset.pantsNote}`;
    const sheetSize = variant.title.match(/22\s*[×x]\s*(12|24|30|36)/i);
    const length = sheetSize?.[1];
    if (selectView) {
      if (root.dataset.kind === 'bottoms') {
        const panel = root.querySelector('[data-preview-panel][data-preview-kind="' + (digital ? 'png' : 'dtf') + '"]');
        if (panel) showView(root, Number(panel.dataset.previewPanel));
      } else if (digital) showView(root, 0);
      else if (length) {
        const sheetButton = root.querySelector('[data-sheet-length="' + length + '"]');
        if (sheetButton) showView(root, Number(sheetButton.dataset.previewIndex));
      }
    }
    const dtfLabel = root.dataset.dtfCart.replace('%size%', length ? '22 × ' + length : '22 × 36');
    document.querySelectorAll('main button[name="add"]:not([disabled]) .add-to-cart-text__content, main .sticky-add-to-cart__button:not([disabled]) .add-to-cart-text__content').forEach(label => label.textContent = digital ? root.dataset.pngCart : dtfLabel);
  };
  const setupGallery = root => {
    if (root.dataset.previewBound) return;
    root.dataset.previewBound = 'true';
    root.querySelectorAll('[data-preview-index]').forEach(button => button.addEventListener('click', () => showView(root, Number(button.dataset.previewIndex))));
    const data = root.querySelector('[data-preview-variants]');
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const id = new URLSearchParams(location.search).get('variant');
    const requested = variants.find(variant => String(variant.id) === id);
    receipt(root, requested || variants[0], {selectView: root.dataset.kind !== 'bottoms' || Boolean(requested)});
  };
  document.addEventListener('variant:update', event => {
    const productId = String(event.detail?.data?.productId || '');
    const id = String(event.detail?.resource?.id || '');
    requestAnimationFrame(() => {
      document.querySelectorAll('[data-compact-gallery]').forEach(root => {
        setupGallery(root);
        if (productId && root.dataset.productId !== productId) return;
        const data = root.querySelector('[data-preview-variants]');
        if (data) receipt(root, JSON.parse(data.textContent).find(variant => String(variant.id) === id));
      });
    });
  });
  const setupRail = root => {
    const grid = root.querySelector('[data-suggestion-grid]');
    if (!grid || !grid.children.length || root.dataset.railBound) return;
    root.dataset.railBound = 'true';
    const pause = root.querySelector('[data-rail-pause]');
    let paused = reduced.matches;
    let hovering = false;
    let focused = false;
    const sync = () => {
      pause.textContent = paused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
      pause.setAttribute('aria-pressed', String(paused));
    };
    const step = direction => {
      const max = grid.scrollWidth - grid.clientWidth;
      const distance = grid.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(grid).columnGap || 0);
      let left = grid.scrollLeft + direction * distance;
      if (left > max + 8) left = 0;
      if (left < -8) left = max;
      grid.scrollTo({left, behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    root.querySelector('[data-rail-prev]').addEventListener('click', () => step(-1));
    root.querySelector('[data-rail-next]').addEventListener('click', () => step(1));
    pause.addEventListener('click', () => { paused = !paused; sync(); });
    grid.addEventListener('mouseenter', () => hovering = true);
    grid.addEventListener('mouseleave', () => hovering = false);
    root.addEventListener('focusin', event => focused = grid.contains(event.target));
    root.addEventListener('focusout', event => { focused = grid.contains(event.relatedTarget); });
    const observer = new IntersectionObserver(entries => { root.dataset.railVisible = String(entries[0].isIntersecting); }, {threshold: .15});
    observer.observe(grid);
    const timer = setInterval(() => {
      if (!root.isConnected) { clearInterval(timer); observer.disconnect(); return; }
      if (!paused && !hovering && !focused && !document.hidden && root.dataset.railVisible === 'true') step(1);
    }, 3000);
    reduced.addEventListener('change', () => { paused = reduced.matches; sync(); });
    sync();
  };
  const fallback = async root => {
    if (root.dataset.fallbackBound) return;
    root.dataset.fallbackBound = 'true';
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${base}recommendations/products.json?product_id=${encodeURIComponent(root.dataset.productId)}&limit=10&intent=related`);
      if (!response.ok) throw new Error('Recommendations unavailable');
      const data = await response.json();
      const grid = root.querySelector('[data-suggestion-grid]');
      for (const product of data.products || []) {
        const card = document.createElement('article'); card.className = 'droid-design-card';
        const link = document.createElement('a'); link.href = product.url;
        const img = document.createElement('img'); img.src = product.featured_image; img.alt = product.title; img.width = 300; img.height = 300; img.loading = 'lazy';
        link.append(img); const title = document.createElement('h3'); title.textContent = product.title; link.append(title); card.append(link); grid.append(card);
      }
      if (!grid.children.length) { root.hidden = true; return; }
      setupRail(root);
    } catch { root.hidden = true; }
  };
  document.addEventListener('droid:rail-ready', event => setupRail(event.target));
  document.addEventListener('droid:recommendations-fallback', event => fallback(event.target));
  const init = () => {
    document.querySelectorAll('[data-compact-gallery]').forEach(setupGallery);
    document.querySelectorAll('[data-suggestions], [data-featured-carousel]').forEach(root => {
      if (root.querySelector('[data-suggestion-grid]')?.children.length) setupRail(root);
      else if (root.dataset.bound) fallback(root);
    });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();
